
import { motion } from 'framer-motion';

interface CategoryBarProps {
  categories: { id: string; name: string; count: number }[];
  selected: string;
  onSelect: (id: string) => void;
}

export default function CategoryBar({ categories, selected, onSelect }: CategoryBarProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex items-center gap-2 overflow-x-auto pb-1 scrollbar-hide"
    >
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
            selected === cat.id
              ? 'bg-gradient-neon text-white shadow-neon-purple'
              : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white border border-white/5'
          }`}
        >
          {cat.name}
          <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${
            selected === cat.id ? 'bg-white/20' : 'bg-white/5'
          }`}>
            {cat.count}
          </span>
        </button>
      ))}
    </motion.div>
  );
}
